import { create } from "zustand"

interface UnpauseConfirmationModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

const useUnpauseConfirmationModalStore = create<UnpauseConfirmationModalStore>(
  (set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  })
)

export default useUnpauseConfirmationModalStore
